import React__default from 'react';

const EmptyBuildingSVG = ()=>{
    return React__default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "198",
        height: "129",
        fill: "none",
        viewBox: "0 0 198 129"
    }, React__default.createElement("g", {
        clipPath: "url(#clip0_5135_483651)"
    }, React__default.createElement("path", {
        fill: "#B3EDDC",
        d: "M30.902 14.419L51.464.539l20.563 13.88v114.404H30.902V14.419z"
    }), React__default.createElement("path", {
        fill: "#00C389",
        d: "M72.029 14.873H109.35499999999999V128.822H72.029z"
    }), React__default.createElement("rect", {
        width: "6.736",
        height: "12.116",
        x: "52.655",
        y: "48.127",
        stroke: "#00C389",
        strokeWidth: "1.514",
        rx: "3.368"
    }), React__default.createElement("path", {
        stroke: "#66DBB8",
        strokeWidth: "1.514",
        d: "M82.076 27.201a3.368 3.368 0 013.368-3.368v0a3.368 3.368 0 013.368 3.368v5.38a3.368 3.368 0 01-3.368 3.368v0a3.368 3.368 0 01-3.368-3.367v-5.38z"
    }), React__default.createElement("rect", {
        width: "6.736",
        height: "12.116",
        x: "82.076",
        y: "48.127",
        stroke: "#66DBB8",
        strokeWidth: "1.514",
        rx: "3.368"
    }), React__default.createElement("rect", {
        width: "6.736",
        height: "12.116",
        x: "41.18",
        y: "76.889",
        stroke: "#00C389",
        strokeWidth: "1.514",
        rx: "3.368"
    }), React__default.createElement("rect", {
        width: "13.534",
        height: "29.254",
        x: "44.699",
        y: "106.341",
        stroke: "#00C389",
        strokeWidth: "1.514",
        rx: "6.767"
    }), React__default.createElement("rect", {
        width: "6.736",
        height: "12.116",
        x: "41.18",
        y: "23.833",
        stroke: "#00C389",
        strokeWidth: "1.514",
        rx: "3.368"
    }), React__default.createElement("path", {
        fill: "#66DBB8",
        d: "M88.49.538H51.494l20.481 14.335h37.378L88.489.538z"
    }), React__default.createElement("path", {
        fill: "#00AF7B",
        d: "M72.116 66.961H81.398V128.822H72.116z"
    })), React__default.createElement("g", {
        clipPath: "url(#clip1_5135_483651)"
    }, React__default.createElement("path", {
        fill: "#B3EDDC",
        d: "M81.398 66.961H137.304V128.822H81.398z"
    }), React__default.createElement("path", {
        fill: "#00C389",
        d: "M124.222 66.96h24.888v61.862h-24.888V66.961z"
    }), React__default.createElement("rect", {
        width: "6.736",
        height: "12.116",
        x: "133.315",
        y: "106.341",
        stroke: "#66DBB8",
        strokeWidth: "1.514",
        rx: "3.368"
    }), React__default.createElement("rect", {
        width: "6.736",
        height: "12.116",
        x: "133.315",
        y: "76.889",
        stroke: "#66DBB8",
        strokeWidth: "1.514",
        rx: "3.368"
    }), React__default.createElement("rect", {
        width: "6.736",
        height: "12.116",
        x: "106.52",
        y: "76.889",
        stroke: "#00C389",
        strokeWidth: "1.514",
        rx: "3.368"
    }), React__default.createElement("rect", {
        width: "13.534",
        height: "29.254",
        x: "102.736",
        y: "106.341",
        stroke: "#00C389",
        strokeWidth: "1.514",
        rx: "6.767"
    }), React__default.createElement("rect", {
        width: "6.736",
        height: "12.116",
        x: "89.743",
        y: "95.984",
        stroke: "#00C389",
        strokeWidth: "1.514",
        rx: "3.368"
    })), React__default.createElement("g", {
        clipPath: "url(#clip2_5135_483651)"
    }, React__default.createElement("circle", {
        cx: "8.556",
        cy: "130.669",
        r: "7.3",
        fill: "#00C389",
        stroke: "#00C389",
        strokeWidth: "1.61"
    }), React__default.createElement("circle", {
        cx: "24.576",
        cy: "128.276",
        r: "9.692",
        fill: "#00C389",
        stroke: "#00C389",
        strokeWidth: "1.61"
    }), React__default.createElement("circle", {
        cx: "175.378",
        cy: "129.171",
        r: "9.809",
        fill: "#00C389",
        stroke: "#00C389",
        strokeWidth: "1.61"
    }), React__default.createElement("circle", {
        cx: "188.454",
        cy: "129.723",
        r: "7.3",
        fill: "#00C389",
        stroke: "#00C389",
        strokeWidth: "1.61"
    }), React__default.createElement("circle", {
        cx: "163.082",
        cy: "131.03",
        r: "5.992",
        fill: "#00C389",
        stroke: "#00C389",
        strokeWidth: "1.61"
    }), React__default.createElement("path", {
        stroke: "#00AF7B",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.468",
        d: "M14.417 88.754v40.05"
    }), React__default.createElement("circle", {
        cx: "14.417",
        cy: "89.454",
        r: "5.104",
        fill: "#fff"
    }), React__default.createElement("path", {
        stroke: "#00C389",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.461",
        d: "M157.09 115.789v14.059"
    }), React__default.createElement("circle", {
        cx: "157.091",
        cy: "107.379",
        r: "11.984",
        fill: "#00AF7B"
    }), React__default.createElement("path", {
        stroke: "#00AF7B",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.461",
        d: "M172.932 112.636v17.212"
    }), React__default.createElement("rect", {
        width: "17.064",
        height: "33.422",
        x: "164.4",
        y: "82.367",
        fill: "#66DBB8",
        rx: "8.532"
    })), React__default.createElement("defs", null, React__default.createElement("clipPath", {
        id: "clip0_5135_483651"
    }, React__default.createElement("path", {
        fill: "#fff",
        d: "M0 0H78.524V128.287H0z",
        transform: "translate(30.828 .614)"
    })), React__default.createElement("clipPath", {
        id: "clip1_5135_483651"
    }, React__default.createElement("path", {
        fill: "#fff",
        d: "M0 0H67.739V61.873H0z",
        transform: "translate(81.375 67.028)"
    })), React__default.createElement("clipPath", {
        id: "clip2_5135_483651"
    }, React__default.createElement("path", {
        fill: "#fff",
        d: "M0 0H197.453V49.788H0z",
        transform: "translate(.026 78.972)"
    }))));
};

export { EmptyBuildingSVG };
